import axios from "axios"
import { CONST_API_EXPORTS_ASSURANCE, CONST_API_EXPORTS_HIERARCHY_PRIME, CONST_API_EXPORTS_TURNOVER_PAR_CONSULTANT } from "../../../endpoints"
import { IExportAssuranceRequestModel, IExportHierarchyPrimeRequestModel, IExportTurnoverParConsultantRequestModel } from "./models"

export function getExportHierarchyPrime(payload: IExportHierarchyPrimeRequestModel) {
     return axios.post(CONST_API_EXPORTS_HIERARCHY_PRIME, payload, {
          responseType: "blob",
     })
}

export function getExportAssurance(payload: IExportAssuranceRequestModel) {
     return axios.post(CONST_API_EXPORTS_ASSURANCE, payload, {
          responseType: "blob",
     })
}

export function getExportTurnoverParConsultant(payload: IExportTurnoverParConsultantRequestModel) {
     return axios.post(CONST_API_EXPORTS_TURNOVER_PAR_CONSULTANT, payload, {
          responseType: "blob",
     })
}
